const typography = {
  fontFamily: ['ST'],
  h1: {
    fontWeight: 700,
    // fontSize: 35,
    // letterSpacing: '-0.24px',
  },
  h2: {
    fontWeight: 700,
    fontSize: 90,
    // letterSpacing: '-0.24px',
  },
  h3: {
    fontWeight: 500,
    // fontSize: 24,
    // letterSpacing: '-0.06px',
  },
  h4: {
    fontWeight: 500,
    // fontSize: 20,
    // letterSpacing: '-0.06px',
  },
  h5: {
    fontWeight: 500,
    fontSize: 28,
    // letterSpacing: '-0.05px',
  },
  h6: {
    fontWeight: 400,
    fontSize: 18,
    lineHeight: 1.2,
    // letterSpacing: '-0.05px',
  },
  overline: {
    fontWeight: 500,
  },
};
export default typography;
